import { gql } from "@apollo/client";

export const CREATE_INSURANCE_DOCUMENT = gql`
  mutation createInsuranceDocument($input: CreateInsuranceDocumentInput!) {
    createInsuranceDocument(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_INSURANCE_DOCUMENT = gql`
  mutation updateInsuranceDocument($input: UpdateInsuranceDocumentInput!) {
    updateInsuranceDocument(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RETRIEVE_EXTERNAL_OFFER_DATA = gql`
  mutation retrieveExternalOfferData($input: RetrieveExternalOfferDataInput!) {
    retrieveExternalOfferData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const COPY_EXTERNAL_OFFER_DATA = gql`
  mutation copyExternalOfferData($input: ExternalOfferDataInput!) {
    copyExternalOfferData(input: $input) {
      commandId
      correlationId
    }
  }
`;
